import { lazy } from 'react';
import { route } from "~/helpers/routeHelper";
import { TRoute } from "~/types/global";

const Meeting = lazy(() => import('~/pages/Meeting/index'));

const publicRoutes: TRoute[] = [];

const protectedRoutes: TRoute[] = [
  { path: route('start_meeting'), component: Meeting },
];

export { publicRoutes, protectedRoutes }
